export const ADMIN_ROOT_PATH = '/admin/dashboard';

/* -------------- PAGES ------------------ */

export const ADMIN_MANAGE_PARTNERS = 'manage-partners';
export const ADMIN_NEWSLETTERS = 'newsletters';
export const ADMIN_POLICES = 'policies';
export const ADMIN_MICRO_TRAINING = 'microTrainings';
export const ADMIN_DARK_WEB = 'darkWeb';
